module.exports = __webpack_public_path__ + "fonts/fs_lola-regular-webfont.52356645.woff2";